import { Component, OnInit, Input, OnDestroy, ElementRef } from '@angular/core';
import echarts from 'echarts';

@Component({
  selector: 'icc-trend-voice-time',
  templateUrl: './icc-trend-voice-time.component.html',
  styleUrls: ['./icc-trend-voice-time.component.less'],
})
export class IccTrendVoiceTimeComponent implements OnInit, OnDestroy {
  constructor(private el: ElementRef) {}

  // 图谱实例
  chartIns: any;
  // 数据源
  @Input() reportType: number;
  @Input() AllTalkTime: any;
  @Input() dayTalkTime: any;
  @Input() data: Array<{
    date: string;
    dayTalkTime: number;
    averTalkTime: number;
  }>;

  dateList: Array<string>;
  barDataList: Array<number>;
  lineDataList: Array<number>;

  // 自适应函数
  resizeCharts = () => {
    if (this.chartIns) {
      this.chartIns.resize();
    }
  };

  ngOnInit() {
    if (this.data instanceof Array && this.data.length) {
      setTimeout(() => {
        this.formatData();
        this.createLineChart('chart-el');
      }, 100);
    }
    window.addEventListener('resize', this.resizeCharts);
  }
  ngOnDestroy() {
    if (this.chartIns) {
      this.chartIns.dispose();
      this.chartIns = null;
    }
    window.removeEventListener('resize', this.resizeCharts);
  }
  formatData() {
    const dateList = [];
    const barDataList = [];
    const lineDataList = [];

    this.data.forEach(item => {
      dateList.push(item.date);
      barDataList.push(item.dayTalkTime);
      lineDataList.push({
        value: item.averTalkTime,
        label: {
          show: true,
          color: 'rgb(63,63,63)',
          formatter: item => {
            return item.value;
          },
        },
      });
    });
    this.dateList = dateList;
    this.barDataList = barDataList;
    this.lineDataList = lineDataList;
  }
  /* 生成图谱 */
  createLineChart(chartCls) {
    const elCollection = this.el.nativeElement.getElementsByClassName(chartCls);
    if (!this.chartIns && elCollection.length) {
      this.chartIns = echarts.init(elCollection[0]);
    }
    const legendItem = {
      itemHeight: 10,
      itemGap: 40,
      align: 'right',
      textStyle: {
        color: '#B4B4B4',
      },
    };
    const axisLabel: any = {
      textStyle: {
        color: '#333',
      },
      formatter: '{value} ',
      margin: 20,
    };
    if (this.data.length >= 10) {
      axisLabel.margin = 10;
      axisLabel.interval = 0;
      axisLabel.rotate = 60;
    }
    this.chartIns.setOption({
      tooltip: {
        trigger: 'axis',
        backgroundColor: 'rgba(0,0,0,0.6)',
      },
      legend: {
        itemHeight: 10,
        itemGap: 40,
        align: 'right',
        textStyle: {
          color: '#B4B4B4',
        },
        data: ['平均通话时长', '日总通话时长'],
      },
      grid: {
        x: '8%',
        width: '82%',
        y: '12%',
        top: '20%',
      },
      xAxis: [
        {
          data: this.dateList,
          boundaryGap: true,
          axisLine: {
            lineStyle: {
              color: '#eee',
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel,
        },
      ],
      yAxis: [
        {
          name: '日均通话时长单位：分钟',
          nameTextStyle: {
            padding: [3, 4, 5, 6],
            color: '#B4B4B4',
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#eee',
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#eee',
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: '#B4B4B4',
            },
            formatter: '{value} ',
          },
        },
        {
          name: '平均通话时长单位：分钟',
          nameTextStyle: {
            padding: [3, 4, 5, 6],
            color: '#B4B4B4',
          },
          splitLine: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#eee',
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            formatter: '{value}',
            textStyle: {
              color: '#B4B4B4',
            },
          },
        },
      ],
      series: this.getSeries(),
    });
  }

  getSeries() {
    const seriesList: any = [
      {
        name: '平均通话时长',
        type: 'line',
        symbolSize: 1,
        yAxisIndex: 1,
        itemStyle: {
          normal: {
            color: 'rgb(52,163,255)',
          },
        },
        data: this.lineDataList,
      },
      {
        name: '日总通话时长',
        type: 'bar',
        yAxisIndex: 0,
        stack: 'count',
        itemStyle: {
          normal: {
            color: 'rgb(36,212,163)',
          },
        },
        data: this.barDataList,
      },
    ];
    seriesList[1].barWidth = 30;
    return seriesList;
  }
}
